// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/distro/distro.proto (package guardianai.v1.distro, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/distro/distro.proto.
 */
export const file_guardianai_v1_distro_distro: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.distro.DistroChecklistItem
 */
export type DistroChecklistItem = Message<"guardianai.v1.distro.DistroChecklistItem"> & {
  /**
   * @generated from field: string item_code = 1;
   */
  itemCode: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string instruction_payload_json = 3;
   */
  instructionPayloadJson: string;

  /**
   * @generated from field: string notes = 4;
   */
  notes: string;

  /**
   * @generated from field: string updated_at = 5;
   */
  updatedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.DistroChecklistItem
 */
export type DistroChecklistItemJson = {
  /**
   * @generated from field: string item_code = 1;
   */
  itemCode?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string instruction_payload_json = 3;
   */
  instructionPayloadJson?: string;

  /**
   * @generated from field: string notes = 4;
   */
  notes?: string;

  /**
   * @generated from field: string updated_at = 5;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroChecklistItem.
 * Use `create(DistroChecklistItemSchema)` to create a new message.
 */
export const DistroChecklistItemSchema: GenMessage<DistroChecklistItem, {jsonType: DistroChecklistItemJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 0);

/**
 * @generated from message guardianai.v1.distro.GetOnboardingChecklistRequest
 */
export type GetOnboardingChecklistRequest = Message<"guardianai.v1.distro.GetOnboardingChecklistRequest"> & {
};

/**
 * @generated from message guardianai.v1.distro.GetOnboardingChecklistRequest
 */
export type GetOnboardingChecklistRequestJson = {
};

/**
 * Describes the message guardianai.v1.distro.GetOnboardingChecklistRequest.
 * Use `create(GetOnboardingChecklistRequestSchema)` to create a new message.
 */
export const GetOnboardingChecklistRequestSchema: GenMessage<GetOnboardingChecklistRequest, {jsonType: GetOnboardingChecklistRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 1);

/**
 * @generated from message guardianai.v1.distro.GetOnboardingChecklistResponse
 */
export type GetOnboardingChecklistResponse = Message<"guardianai.v1.distro.GetOnboardingChecklistResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroChecklistItem items = 1;
   */
  items: DistroChecklistItem[];

  /**
   * @generated from field: bool white_glove_enabled = 2;
   */
  whiteGloveEnabled: boolean;

  /**
   * @generated from field: bool managed_pilot_enabled = 3;
   */
  managedPilotEnabled: boolean;
};

/**
 * @generated from message guardianai.v1.distro.GetOnboardingChecklistResponse
 */
export type GetOnboardingChecklistResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroChecklistItem items = 1;
   */
  items?: DistroChecklistItemJson[];

  /**
   * @generated from field: bool white_glove_enabled = 2;
   */
  whiteGloveEnabled?: boolean;

  /**
   * @generated from field: bool managed_pilot_enabled = 3;
   */
  managedPilotEnabled?: boolean;
};

/**
 * Describes the message guardianai.v1.distro.GetOnboardingChecklistResponse.
 * Use `create(GetOnboardingChecklistResponseSchema)` to create a new message.
 */
export const GetOnboardingChecklistResponseSchema: GenMessage<GetOnboardingChecklistResponse, {jsonType: GetOnboardingChecklistResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 2);

/**
 * @generated from message guardianai.v1.distro.UpdateChecklistItemRequest
 */
export type UpdateChecklistItemRequest = Message<"guardianai.v1.distro.UpdateChecklistItemRequest"> & {
  /**
   * @generated from field: string item_code = 1;
   */
  itemCode: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.distro.UpdateChecklistItemRequest
 */
export type UpdateChecklistItemRequestJson = {
  /**
   * @generated from field: string item_code = 1;
   */
  itemCode?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.distro.UpdateChecklistItemRequest.
 * Use `create(UpdateChecklistItemRequestSchema)` to create a new message.
 */
export const UpdateChecklistItemRequestSchema: GenMessage<UpdateChecklistItemRequest, {jsonType: UpdateChecklistItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 3);

/**
 * @generated from message guardianai.v1.distro.UpdateChecklistItemResponse
 */
export type UpdateChecklistItemResponse = Message<"guardianai.v1.distro.UpdateChecklistItemResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroChecklistItem item = 1;
   */
  item?: DistroChecklistItem;
};

/**
 * @generated from message guardianai.v1.distro.UpdateChecklistItemResponse
 */
export type UpdateChecklistItemResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroChecklistItem item = 1;
   */
  item?: DistroChecklistItemJson;
};

/**
 * Describes the message guardianai.v1.distro.UpdateChecklistItemResponse.
 * Use `create(UpdateChecklistItemResponseSchema)` to create a new message.
 */
export const UpdateChecklistItemResponseSchema: GenMessage<UpdateChecklistItemResponse, {jsonType: UpdateChecklistItemResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 4);

/**
 * @generated from message guardianai.v1.distro.RunCompliancePreflightRequest
 */
export type RunCompliancePreflightRequest = Message<"guardianai.v1.distro.RunCompliancePreflightRequest"> & {
};

/**
 * @generated from message guardianai.v1.distro.RunCompliancePreflightRequest
 */
export type RunCompliancePreflightRequestJson = {
};

/**
 * Describes the message guardianai.v1.distro.RunCompliancePreflightRequest.
 * Use `create(RunCompliancePreflightRequestSchema)` to create a new message.
 */
export const RunCompliancePreflightRequestSchema: GenMessage<RunCompliancePreflightRequest, {jsonType: RunCompliancePreflightRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 5);

/**
 * @generated from message guardianai.v1.distro.RunCompliancePreflightResponse
 */
export type RunCompliancePreflightResponse = Message<"guardianai.v1.distro.RunCompliancePreflightResponse"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: repeated string blocking_issues = 2;
   */
  blockingIssues: string[];

  /**
   * @generated from field: string checked_at = 3;
   */
  checkedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.RunCompliancePreflightResponse
 */
export type RunCompliancePreflightResponseJson = {
  /**
   * @generated from field: string status = 1;
   */
  status?: string;

  /**
   * @generated from field: repeated string blocking_issues = 2;
   */
  blockingIssues?: string[];

  /**
   * @generated from field: string checked_at = 3;
   */
  checkedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.RunCompliancePreflightResponse.
 * Use `create(RunCompliancePreflightResponseSchema)` to create a new message.
 */
export const RunCompliancePreflightResponseSchema: GenMessage<RunCompliancePreflightResponse, {jsonType: RunCompliancePreflightResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 6);

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionsRequest
 */
export type ListOnboardingActionsRequest = Message<"guardianai.v1.distro.ListOnboardingActionsRequest"> & {
  /**
   * @generated from field: string unit_code = 1;
   */
  unitCode: string;
};

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionsRequest
 */
export type ListOnboardingActionsRequestJson = {
  /**
   * @generated from field: string unit_code = 1;
   */
  unitCode?: string;
};

/**
 * Describes the message guardianai.v1.distro.ListOnboardingActionsRequest.
 * Use `create(ListOnboardingActionsRequestSchema)` to create a new message.
 */
export const ListOnboardingActionsRequestSchema: GenMessage<ListOnboardingActionsRequest, {jsonType: ListOnboardingActionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 7);

/**
 * @generated from message guardianai.v1.distro.DistroOnboardingAction
 */
export type DistroOnboardingAction = Message<"guardianai.v1.distro.DistroOnboardingAction"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string checklist_item_code = 2;
   */
  checklistItemCode: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string execution_mode = 5;
   */
  executionMode: string;

  /**
   * @generated from field: string cta_label = 6;
   */
  ctaLabel: string;

  /**
   * @generated from field: string cta_type = 7;
   */
  ctaType: string;

  /**
   * @generated from field: string cta_target = 8;
   */
  ctaTarget: string;

  /**
   * @generated from field: bool blocked = 9;
   */
  blocked: boolean;

  /**
   * @generated from field: string blocked_reason = 10;
   */
  blockedReason: string;

  /**
   * @generated from field: string status = 11;
   */
  status: string;

  /**
   * @generated from field: string last_run_at = 12;
   */
  lastRunAt: string;

  /**
   * @generated from field: string last_run_status = 13;
   */
  lastRunStatus: string;

  /**
   * @generated from field: string last_run_message = 14;
   */
  lastRunMessage: string;

  /**
   * @generated from field: string unit_code = 15;
   */
  unitCode: string;

  /**
   * @generated from field: string support_tier = 16;
   */
  supportTier: string;

  /**
   * @generated from field: string guidance_payload_json = 17;
   */
  guidancePayloadJson: string;

  /**
   * @generated from field: string input_schema_json = 18;
   */
  inputSchemaJson: string;

  /**
   * @generated from field: string output_schema_json = 19;
   */
  outputSchemaJson: string;

  /**
   * @generated from field: string latest_operation_id = 20;
   */
  latestOperationId: string;

  /**
   * @generated from field: string latest_operation_status = 21;
   */
  latestOperationStatus: string;

  /**
   * @generated from field: bool requires_evidence = 22;
   */
  requiresEvidence: boolean;

  /**
   * @generated from field: string evidence_schema_json = 23;
   */
  evidenceSchemaJson: string;

  /**
   * @generated from field: string default_input_payload_json = 24;
   */
  defaultInputPayloadJson: string;
};

/**
 * @generated from message guardianai.v1.distro.DistroOnboardingAction
 */
export type DistroOnboardingActionJson = {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId?: string;

  /**
   * @generated from field: string checklist_item_code = 2;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: string execution_mode = 5;
   */
  executionMode?: string;

  /**
   * @generated from field: string cta_label = 6;
   */
  ctaLabel?: string;

  /**
   * @generated from field: string cta_type = 7;
   */
  ctaType?: string;

  /**
   * @generated from field: string cta_target = 8;
   */
  ctaTarget?: string;

  /**
   * @generated from field: bool blocked = 9;
   */
  blocked?: boolean;

  /**
   * @generated from field: string blocked_reason = 10;
   */
  blockedReason?: string;

  /**
   * @generated from field: string status = 11;
   */
  status?: string;

  /**
   * @generated from field: string last_run_at = 12;
   */
  lastRunAt?: string;

  /**
   * @generated from field: string last_run_status = 13;
   */
  lastRunStatus?: string;

  /**
   * @generated from field: string last_run_message = 14;
   */
  lastRunMessage?: string;

  /**
   * @generated from field: string unit_code = 15;
   */
  unitCode?: string;

  /**
   * @generated from field: string support_tier = 16;
   */
  supportTier?: string;

  /**
   * @generated from field: string guidance_payload_json = 17;
   */
  guidancePayloadJson?: string;

  /**
   * @generated from field: string input_schema_json = 18;
   */
  inputSchemaJson?: string;

  /**
   * @generated from field: string output_schema_json = 19;
   */
  outputSchemaJson?: string;

  /**
   * @generated from field: string latest_operation_id = 20;
   */
  latestOperationId?: string;

  /**
   * @generated from field: string latest_operation_status = 21;
   */
  latestOperationStatus?: string;

  /**
   * @generated from field: bool requires_evidence = 22;
   */
  requiresEvidence?: boolean;

  /**
   * @generated from field: string evidence_schema_json = 23;
   */
  evidenceSchemaJson?: string;

  /**
   * @generated from field: string default_input_payload_json = 24;
   */
  defaultInputPayloadJson?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroOnboardingAction.
 * Use `create(DistroOnboardingActionSchema)` to create a new message.
 */
export const DistroOnboardingActionSchema: GenMessage<DistroOnboardingAction, {jsonType: DistroOnboardingActionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 8);

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionsResponse
 */
export type ListOnboardingActionsResponse = Message<"guardianai.v1.distro.ListOnboardingActionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroOnboardingAction actions = 1;
   */
  actions: DistroOnboardingAction[];
};

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionsResponse
 */
export type ListOnboardingActionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroOnboardingAction actions = 1;
   */
  actions?: DistroOnboardingActionJson[];
};

/**
 * Describes the message guardianai.v1.distro.ListOnboardingActionsResponse.
 * Use `create(ListOnboardingActionsResponseSchema)` to create a new message.
 */
export const ListOnboardingActionsResponseSchema: GenMessage<ListOnboardingActionsResponse, {jsonType: ListOnboardingActionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 9);

/**
 * @generated from message guardianai.v1.distro.ExecuteOnboardingActionRequest
 */
export type ExecuteOnboardingActionRequest = Message<"guardianai.v1.distro.ExecuteOnboardingActionRequest"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string input_payload_json = 2;
   */
  inputPayloadJson: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: bool dry_run = 5;
   */
  dryRun: boolean;

  /**
   * @generated from field: string requested_by_role = 6;
   */
  requestedByRole: string;
};

/**
 * @generated from message guardianai.v1.distro.ExecuteOnboardingActionRequest
 */
export type ExecuteOnboardingActionRequestJson = {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId?: string;

  /**
   * @generated from field: string input_payload_json = 2;
   */
  inputPayloadJson?: string;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey?: string;

  /**
   * @generated from field: string source = 4;
   */
  source?: string;

  /**
   * @generated from field: bool dry_run = 5;
   */
  dryRun?: boolean;

  /**
   * @generated from field: string requested_by_role = 6;
   */
  requestedByRole?: string;
};

/**
 * Describes the message guardianai.v1.distro.ExecuteOnboardingActionRequest.
 * Use `create(ExecuteOnboardingActionRequestSchema)` to create a new message.
 */
export const ExecuteOnboardingActionRequestSchema: GenMessage<ExecuteOnboardingActionRequest, {jsonType: ExecuteOnboardingActionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 10);

/**
 * @generated from message guardianai.v1.distro.ExecuteOnboardingActionResponse
 */
export type ExecuteOnboardingActionResponse = Message<"guardianai.v1.distro.ExecuteOnboardingActionResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroOnboardingAction action = 1;
   */
  action?: DistroOnboardingAction;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: string operation_status = 3;
   */
  operationStatus: string;

  /**
   * @generated from field: string operation_message = 4;
   */
  operationMessage: string;

  /**
   * @generated from field: string operation_started_at = 5;
   */
  operationStartedAt: string;

  /**
   * @generated from field: string operation_updated_at = 6;
   */
  operationUpdatedAt: string;

  /**
   * @generated from field: string operation_result_payload_json = 7;
   */
  operationResultPayloadJson: string;

  /**
   * @generated from field: repeated string blocking_issues = 8;
   */
  blockingIssues: string[];

  /**
   * @generated from field: repeated string suggested_next_action_ids = 9;
   */
  suggestedNextActionIds: string[];
};

/**
 * @generated from message guardianai.v1.distro.ExecuteOnboardingActionResponse
 */
export type ExecuteOnboardingActionResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroOnboardingAction action = 1;
   */
  action?: DistroOnboardingActionJson;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId?: string;

  /**
   * @generated from field: string operation_status = 3;
   */
  operationStatus?: string;

  /**
   * @generated from field: string operation_message = 4;
   */
  operationMessage?: string;

  /**
   * @generated from field: string operation_started_at = 5;
   */
  operationStartedAt?: string;

  /**
   * @generated from field: string operation_updated_at = 6;
   */
  operationUpdatedAt?: string;

  /**
   * @generated from field: string operation_result_payload_json = 7;
   */
  operationResultPayloadJson?: string;

  /**
   * @generated from field: repeated string blocking_issues = 8;
   */
  blockingIssues?: string[];

  /**
   * @generated from field: repeated string suggested_next_action_ids = 9;
   */
  suggestedNextActionIds?: string[];
};

/**
 * Describes the message guardianai.v1.distro.ExecuteOnboardingActionResponse.
 * Use `create(ExecuteOnboardingActionResponseSchema)` to create a new message.
 */
export const ExecuteOnboardingActionResponseSchema: GenMessage<ExecuteOnboardingActionResponse, {jsonType: ExecuteOnboardingActionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 11);

/**
 * @generated from message guardianai.v1.distro.UploadOnboardingEvidenceRequest
 */
export type UploadOnboardingEvidenceRequest = Message<"guardianai.v1.distro.UploadOnboardingEvidenceRequest"> & {
  /**
   * @generated from field: string checklist_item_code = 1;
   */
  checklistItemCode: string;

  /**
   * @generated from field: bytes file_data = 2;
   */
  fileData: Uint8Array;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType: string;

  /**
   * @generated from field: string idempotency_key = 5;
   */
  idempotencyKey: string;
};

/**
 * @generated from message guardianai.v1.distro.UploadOnboardingEvidenceRequest
 */
export type UploadOnboardingEvidenceRequestJson = {
  /**
   * @generated from field: string checklist_item_code = 1;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: bytes file_data = 2;
   */
  fileData?: string;

  /**
   * @generated from field: string file_name = 3;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 4;
   */
  mimeType?: string;

  /**
   * @generated from field: string idempotency_key = 5;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message guardianai.v1.distro.UploadOnboardingEvidenceRequest.
 * Use `create(UploadOnboardingEvidenceRequestSchema)` to create a new message.
 */
export const UploadOnboardingEvidenceRequestSchema: GenMessage<UploadOnboardingEvidenceRequest, {jsonType: UploadOnboardingEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 12);

/**
 * @generated from message guardianai.v1.distro.UploadOnboardingEvidenceResponse
 */
export type UploadOnboardingEvidenceResponse = Message<"guardianai.v1.distro.UploadOnboardingEvidenceResponse"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string storage_ref = 2;
   */
  storageRef: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;
};

/**
 * @generated from message guardianai.v1.distro.UploadOnboardingEvidenceResponse
 */
export type UploadOnboardingEvidenceResponseJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string storage_ref = 2;
   */
  storageRef?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;
};

/**
 * Describes the message guardianai.v1.distro.UploadOnboardingEvidenceResponse.
 * Use `create(UploadOnboardingEvidenceResponseSchema)` to create a new message.
 */
export const UploadOnboardingEvidenceResponseSchema: GenMessage<UploadOnboardingEvidenceResponse, {jsonType: UploadOnboardingEvidenceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 13);

/**
 * @generated from message guardianai.v1.distro.GetOnboardingActionOperationRequest
 */
export type GetOnboardingActionOperationRequest = Message<"guardianai.v1.distro.GetOnboardingActionOperationRequest"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;
};

/**
 * @generated from message guardianai.v1.distro.GetOnboardingActionOperationRequest
 */
export type GetOnboardingActionOperationRequestJson = {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId?: string;
};

/**
 * Describes the message guardianai.v1.distro.GetOnboardingActionOperationRequest.
 * Use `create(GetOnboardingActionOperationRequestSchema)` to create a new message.
 */
export const GetOnboardingActionOperationRequestSchema: GenMessage<GetOnboardingActionOperationRequest, {jsonType: GetOnboardingActionOperationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 14);

/**
 * @generated from message guardianai.v1.distro.DistroOnboardingActionOperation
 */
export type DistroOnboardingActionOperation = Message<"guardianai.v1.distro.DistroOnboardingActionOperation"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: string action_id = 2;
   */
  actionId: string;

  /**
   * @generated from field: string checklist_item_code = 3;
   */
  checklistItemCode: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string requested_by = 6;
   */
  requestedBy: string;

  /**
   * @generated from field: string requested_by_role = 7;
   */
  requestedByRole: string;

  /**
   * @generated from field: string input_payload_json = 8;
   */
  inputPayloadJson: string;

  /**
   * @generated from field: string result_payload_json = 9;
   */
  resultPayloadJson: string;

  /**
   * @generated from field: string error_code = 10;
   */
  errorCode: string;

  /**
   * @generated from field: string error_message = 11;
   */
  errorMessage: string;

  /**
   * @generated from field: repeated string blocking_issues = 12;
   */
  blockingIssues: string[];

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt: string;

  /**
   * @generated from field: string started_at = 14;
   */
  startedAt: string;

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt: string;

  /**
   * @generated from field: string completed_at = 16;
   */
  completedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.DistroOnboardingActionOperation
 */
export type DistroOnboardingActionOperationJson = {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId?: string;

  /**
   * @generated from field: string action_id = 2;
   */
  actionId?: string;

  /**
   * @generated from field: string checklist_item_code = 3;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string source = 5;
   */
  source?: string;

  /**
   * @generated from field: string requested_by = 6;
   */
  requestedBy?: string;

  /**
   * @generated from field: string requested_by_role = 7;
   */
  requestedByRole?: string;

  /**
   * @generated from field: string input_payload_json = 8;
   */
  inputPayloadJson?: string;

  /**
   * @generated from field: string result_payload_json = 9;
   */
  resultPayloadJson?: string;

  /**
   * @generated from field: string error_code = 10;
   */
  errorCode?: string;

  /**
   * @generated from field: string error_message = 11;
   */
  errorMessage?: string;

  /**
   * @generated from field: repeated string blocking_issues = 12;
   */
  blockingIssues?: string[];

  /**
   * @generated from field: string created_at = 13;
   */
  createdAt?: string;

  /**
   * @generated from field: string started_at = 14;
   */
  startedAt?: string;

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt?: string;

  /**
   * @generated from field: string completed_at = 16;
   */
  completedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroOnboardingActionOperation.
 * Use `create(DistroOnboardingActionOperationSchema)` to create a new message.
 */
export const DistroOnboardingActionOperationSchema: GenMessage<DistroOnboardingActionOperation, {jsonType: DistroOnboardingActionOperationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 15);

/**
 * @generated from message guardianai.v1.distro.GetOnboardingActionOperationResponse
 */
export type GetOnboardingActionOperationResponse = Message<"guardianai.v1.distro.GetOnboardingActionOperationResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroOnboardingActionOperation operation = 1;
   */
  operation?: DistroOnboardingActionOperation;
};

/**
 * @generated from message guardianai.v1.distro.GetOnboardingActionOperationResponse
 */
export type GetOnboardingActionOperationResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroOnboardingActionOperation operation = 1;
   */
  operation?: DistroOnboardingActionOperationJson;
};

/**
 * Describes the message guardianai.v1.distro.GetOnboardingActionOperationResponse.
 * Use `create(GetOnboardingActionOperationResponseSchema)` to create a new message.
 */
export const GetOnboardingActionOperationResponseSchema: GenMessage<GetOnboardingActionOperationResponse, {jsonType: GetOnboardingActionOperationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 16);

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionOperationsRequest
 */
export type ListOnboardingActionOperationsRequest = Message<"guardianai.v1.distro.ListOnboardingActionOperationsRequest"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionOperationsRequest
 */
export type ListOnboardingActionOperationsRequestJson = {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListOnboardingActionOperationsRequest.
 * Use `create(ListOnboardingActionOperationsRequestSchema)` to create a new message.
 */
export const ListOnboardingActionOperationsRequestSchema: GenMessage<ListOnboardingActionOperationsRequest, {jsonType: ListOnboardingActionOperationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 17);

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionOperationsResponse
 */
export type ListOnboardingActionOperationsResponse = Message<"guardianai.v1.distro.ListOnboardingActionOperationsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroOnboardingActionOperation operations = 1;
   */
  operations: DistroOnboardingActionOperation[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.ListOnboardingActionOperationsResponse
 */
export type ListOnboardingActionOperationsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroOnboardingActionOperation operations = 1;
   */
  operations?: DistroOnboardingActionOperationJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListOnboardingActionOperationsResponse.
 * Use `create(ListOnboardingActionOperationsResponseSchema)` to create a new message.
 */
export const ListOnboardingActionOperationsResponseSchema: GenMessage<ListOnboardingActionOperationsResponse, {jsonType: ListOnboardingActionOperationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 18);

/**
 * @generated from message guardianai.v1.distro.RequestWhiteGloveEngagementRequest
 */
export type RequestWhiteGloveEngagementRequest = Message<"guardianai.v1.distro.RequestWhiteGloveEngagementRequest"> & {
  /**
   * @generated from field: string checklist_item_code = 1;
   */
  checklistItemCode: string;

  /**
   * @generated from field: string objective = 2;
   */
  objective: string;

  /**
   * @generated from field: string context_payload_json = 3;
   */
  contextPayloadJson: string;

  /**
   * @generated from field: string urgency = 4;
   */
  urgency: string;

  /**
   * @generated from field: string action_id = 5;
   */
  actionId: string;

  /**
   * @generated from field: string requester_channel = 6;
   */
  requesterChannel: string;

  /**
   * @generated from field: string preferred_contact = 7;
   */
  preferredContact: string;

  /**
   * @generated from field: string requested_due_at = 8;
   */
  requestedDueAt: string;

  /**
   * @generated from field: string source = 9;
   */
  source: string;

  /**
   * @generated from field: string idempotency_key = 10;
   */
  idempotencyKey: string;
};

/**
 * @generated from message guardianai.v1.distro.RequestWhiteGloveEngagementRequest
 */
export type RequestWhiteGloveEngagementRequestJson = {
  /**
   * @generated from field: string checklist_item_code = 1;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: string objective = 2;
   */
  objective?: string;

  /**
   * @generated from field: string context_payload_json = 3;
   */
  contextPayloadJson?: string;

  /**
   * @generated from field: string urgency = 4;
   */
  urgency?: string;

  /**
   * @generated from field: string action_id = 5;
   */
  actionId?: string;

  /**
   * @generated from field: string requester_channel = 6;
   */
  requesterChannel?: string;

  /**
   * @generated from field: string preferred_contact = 7;
   */
  preferredContact?: string;

  /**
   * @generated from field: string requested_due_at = 8;
   */
  requestedDueAt?: string;

  /**
   * @generated from field: string source = 9;
   */
  source?: string;

  /**
   * @generated from field: string idempotency_key = 10;
   */
  idempotencyKey?: string;
};

/**
 * Describes the message guardianai.v1.distro.RequestWhiteGloveEngagementRequest.
 * Use `create(RequestWhiteGloveEngagementRequestSchema)` to create a new message.
 */
export const RequestWhiteGloveEngagementRequestSchema: GenMessage<RequestWhiteGloveEngagementRequest, {jsonType: RequestWhiteGloveEngagementRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 19);

/**
 * @generated from message guardianai.v1.distro.RequestWhiteGloveEngagementResponse
 */
export type RequestWhiteGloveEngagementResponse = Message<"guardianai.v1.distro.RequestWhiteGloveEngagementResponse"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string assigned_team = 3;
   */
  assignedTeam: string;

  /**
   * @generated from field: string eta = 4;
   */
  eta: string;

  /**
   * @generated from field: string triage_summary = 5;
   */
  triageSummary: string;

  /**
   * @generated from field: string next_step = 6;
   */
  nextStep: string;

  /**
   * @generated from field: string portal_url = 7;
   */
  portalUrl: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.RequestWhiteGloveEngagementResponse
 */
export type RequestWhiteGloveEngagementResponseJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string assigned_team = 3;
   */
  assignedTeam?: string;

  /**
   * @generated from field: string eta = 4;
   */
  eta?: string;

  /**
   * @generated from field: string triage_summary = 5;
   */
  triageSummary?: string;

  /**
   * @generated from field: string next_step = 6;
   */
  nextStep?: string;

  /**
   * @generated from field: string portal_url = 7;
   */
  portalUrl?: string;

  /**
   * @generated from field: string created_at = 8;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.RequestWhiteGloveEngagementResponse.
 * Use `create(RequestWhiteGloveEngagementResponseSchema)` to create a new message.
 */
export const RequestWhiteGloveEngagementResponseSchema: GenMessage<RequestWhiteGloveEngagementResponse, {jsonType: RequestWhiteGloveEngagementResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 20);

/**
 * @generated from message guardianai.v1.distro.DistroWhiteGloveEngagement
 */
export type DistroWhiteGloveEngagement = Message<"guardianai.v1.distro.DistroWhiteGloveEngagement"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * @generated from field: string action_id = 2;
   */
  actionId: string;

  /**
   * @generated from field: string checklist_item_code = 3;
   */
  checklistItemCode: string;

  /**
   * @generated from field: string objective = 4;
   */
  objective: string;

  /**
   * @generated from field: string urgency = 5;
   */
  urgency: string;

  /**
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * @generated from field: string assigned_team = 7;
   */
  assignedTeam: string;

  /**
   * @generated from field: string assigned_owner = 8;
   */
  assignedOwner: string;

  /**
   * @generated from field: string eta = 9;
   */
  eta: string;

  /**
   * @generated from field: string triage_summary = 10;
   */
  triageSummary: string;

  /**
   * @generated from field: string next_step = 11;
   */
  nextStep: string;

  /**
   * @generated from field: string portal_url = 12;
   */
  portalUrl: string;

  /**
   * @generated from field: string context_payload_json = 13;
   */
  contextPayloadJson: string;

  /**
   * @generated from field: string source = 14;
   */
  source: string;

  /**
   * @generated from field: string preferred_contact = 15;
   */
  preferredContact: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt: string;

  /**
   * @generated from field: string resolved_at = 18;
   */
  resolvedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.DistroWhiteGloveEngagement
 */
export type DistroWhiteGloveEngagementJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;

  /**
   * @generated from field: string action_id = 2;
   */
  actionId?: string;

  /**
   * @generated from field: string checklist_item_code = 3;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: string objective = 4;
   */
  objective?: string;

  /**
   * @generated from field: string urgency = 5;
   */
  urgency?: string;

  /**
   * @generated from field: string status = 6;
   */
  status?: string;

  /**
   * @generated from field: string assigned_team = 7;
   */
  assignedTeam?: string;

  /**
   * @generated from field: string assigned_owner = 8;
   */
  assignedOwner?: string;

  /**
   * @generated from field: string eta = 9;
   */
  eta?: string;

  /**
   * @generated from field: string triage_summary = 10;
   */
  triageSummary?: string;

  /**
   * @generated from field: string next_step = 11;
   */
  nextStep?: string;

  /**
   * @generated from field: string portal_url = 12;
   */
  portalUrl?: string;

  /**
   * @generated from field: string context_payload_json = 13;
   */
  contextPayloadJson?: string;

  /**
   * @generated from field: string source = 14;
   */
  source?: string;

  /**
   * @generated from field: string preferred_contact = 15;
   */
  preferredContact?: string;

  /**
   * @generated from field: string created_at = 16;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 17;
   */
  updatedAt?: string;

  /**
   * @generated from field: string resolved_at = 18;
   */
  resolvedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroWhiteGloveEngagement.
 * Use `create(DistroWhiteGloveEngagementSchema)` to create a new message.
 */
export const DistroWhiteGloveEngagementSchema: GenMessage<DistroWhiteGloveEngagement, {jsonType: DistroWhiteGloveEngagementJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 21);

/**
 * @generated from message guardianai.v1.distro.GetWhiteGloveEngagementRequest
 */
export type GetWhiteGloveEngagementRequest = Message<"guardianai.v1.distro.GetWhiteGloveEngagementRequest"> & {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId: string;
};

/**
 * @generated from message guardianai.v1.distro.GetWhiteGloveEngagementRequest
 */
export type GetWhiteGloveEngagementRequestJson = {
  /**
   * @generated from field: string request_id = 1;
   */
  requestId?: string;
};

/**
 * Describes the message guardianai.v1.distro.GetWhiteGloveEngagementRequest.
 * Use `create(GetWhiteGloveEngagementRequestSchema)` to create a new message.
 */
export const GetWhiteGloveEngagementRequestSchema: GenMessage<GetWhiteGloveEngagementRequest, {jsonType: GetWhiteGloveEngagementRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 22);

/**
 * @generated from message guardianai.v1.distro.GetWhiteGloveEngagementResponse
 */
export type GetWhiteGloveEngagementResponse = Message<"guardianai.v1.distro.GetWhiteGloveEngagementResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroWhiteGloveEngagement engagement = 1;
   */
  engagement?: DistroWhiteGloveEngagement;
};

/**
 * @generated from message guardianai.v1.distro.GetWhiteGloveEngagementResponse
 */
export type GetWhiteGloveEngagementResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroWhiteGloveEngagement engagement = 1;
   */
  engagement?: DistroWhiteGloveEngagementJson;
};

/**
 * Describes the message guardianai.v1.distro.GetWhiteGloveEngagementResponse.
 * Use `create(GetWhiteGloveEngagementResponseSchema)` to create a new message.
 */
export const GetWhiteGloveEngagementResponseSchema: GenMessage<GetWhiteGloveEngagementResponse, {jsonType: GetWhiteGloveEngagementResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 23);

/**
 * @generated from message guardianai.v1.distro.ListWhiteGloveEngagementsRequest
 */
export type ListWhiteGloveEngagementsRequest = Message<"guardianai.v1.distro.ListWhiteGloveEngagementsRequest"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: string checklist_item_code = 2;
   */
  checklistItemCode: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.distro.ListWhiteGloveEngagementsRequest
 */
export type ListWhiteGloveEngagementsRequestJson = {
  /**
   * @generated from field: string status = 1;
   */
  status?: string;

  /**
   * @generated from field: string checklist_item_code = 2;
   */
  checklistItemCode?: string;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListWhiteGloveEngagementsRequest.
 * Use `create(ListWhiteGloveEngagementsRequestSchema)` to create a new message.
 */
export const ListWhiteGloveEngagementsRequestSchema: GenMessage<ListWhiteGloveEngagementsRequest, {jsonType: ListWhiteGloveEngagementsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 24);

/**
 * @generated from message guardianai.v1.distro.ListWhiteGloveEngagementsResponse
 */
export type ListWhiteGloveEngagementsResponse = Message<"guardianai.v1.distro.ListWhiteGloveEngagementsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroWhiteGloveEngagement engagements = 1;
   */
  engagements: DistroWhiteGloveEngagement[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.ListWhiteGloveEngagementsResponse
 */
export type ListWhiteGloveEngagementsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroWhiteGloveEngagement engagements = 1;
   */
  engagements?: DistroWhiteGloveEngagementJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListWhiteGloveEngagementsResponse.
 * Use `create(ListWhiteGloveEngagementsResponseSchema)` to create a new message.
 */
export const ListWhiteGloveEngagementsResponseSchema: GenMessage<ListWhiteGloveEngagementsResponse, {jsonType: ListWhiteGloveEngagementsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 25);

/**
 * @generated from message guardianai.v1.distro.DistroReleaseJob
 */
export type DistroReleaseJob = Message<"guardianai.v1.distro.DistroReleaseJob"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string app_name = 2;
   */
  appName: string;

  /**
   * @generated from field: repeated string platform_targets = 3;
   */
  platformTargets: string[];

  /**
   * @generated from field: string release_track = 4;
   */
  releaseTrack: string;

  /**
   * @generated from field: int32 rollout_percentage = 5;
   */
  rolloutPercentage: number;

  /**
   * @generated from field: string release_version = 6;
   */
  releaseVersion: string;

  /**
   * @generated from field: string build_artifact_uri = 7;
   */
  buildArtifactUri: string;

  /**
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: int32 attempt_count = 9;
   */
  attemptCount: number;

  /**
   * @generated from field: int32 max_attempts = 10;
   */
  maxAttempts: number;

  /**
   * @generated from field: string idempotency_key = 11;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string correlation_id = 12;
   */
  correlationId: string;

  /**
   * @generated from field: string last_error = 13;
   */
  lastError: string;

  /**
   * @generated from field: string created_at = 14;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt: string;

  /**
   * @generated from field: string completed_at = 16;
   */
  completedAt: string;

  /**
   * @generated from field: optional string artifact_sha256 = 17;
   */
  artifactSha256?: string;

  /**
   * @generated from field: optional int64 artifact_byte_size = 18;
   */
  artifactByteSize?: bigint;
};

/**
 * @generated from message guardianai.v1.distro.DistroReleaseJob
 */
export type DistroReleaseJobJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string app_name = 2;
   */
  appName?: string;

  /**
   * @generated from field: repeated string platform_targets = 3;
   */
  platformTargets?: string[];

  /**
   * @generated from field: string release_track = 4;
   */
  releaseTrack?: string;

  /**
   * @generated from field: int32 rollout_percentage = 5;
   */
  rolloutPercentage?: number;

  /**
   * @generated from field: string release_version = 6;
   */
  releaseVersion?: string;

  /**
   * @generated from field: string build_artifact_uri = 7;
   */
  buildArtifactUri?: string;

  /**
   * @generated from field: string status = 8;
   */
  status?: string;

  /**
   * @generated from field: int32 attempt_count = 9;
   */
  attemptCount?: number;

  /**
   * @generated from field: int32 max_attempts = 10;
   */
  maxAttempts?: number;

  /**
   * @generated from field: string idempotency_key = 11;
   */
  idempotencyKey?: string;

  /**
   * @generated from field: string correlation_id = 12;
   */
  correlationId?: string;

  /**
   * @generated from field: string last_error = 13;
   */
  lastError?: string;

  /**
   * @generated from field: string created_at = 14;
   */
  createdAt?: string;

  /**
   * @generated from field: string updated_at = 15;
   */
  updatedAt?: string;

  /**
   * @generated from field: string completed_at = 16;
   */
  completedAt?: string;

  /**
   * @generated from field: optional string artifact_sha256 = 17;
   */
  artifactSha256?: string;

  /**
   * @generated from field: optional int64 artifact_byte_size = 18;
   */
  artifactByteSize?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroReleaseJob.
 * Use `create(DistroReleaseJobSchema)` to create a new message.
 */
export const DistroReleaseJobSchema: GenMessage<DistroReleaseJob, {jsonType: DistroReleaseJobJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 26);

/**
 * @generated from message guardianai.v1.distro.CreateReleaseJobRequest
 */
export type CreateReleaseJobRequest = Message<"guardianai.v1.distro.CreateReleaseJobRequest"> & {
  /**
   * @generated from field: string app_name = 1;
   */
  appName: string;

  /**
   * @generated from field: repeated string platform_targets = 2;
   */
  platformTargets: string[];

  /**
   * @generated from field: string release_track = 3;
   */
  releaseTrack: string;

  /**
   * @generated from field: int32 rollout_percentage = 4;
   */
  rolloutPercentage: number;

  /**
   * @generated from field: string release_version = 5;
   */
  releaseVersion: string;

  /**
   * @generated from field: string build_artifact_uri = 6;
   */
  buildArtifactUri: string;

  /**
   * @generated from field: string idempotency_key = 7;
   */
  idempotencyKey: string;

  /**
   * @generated from field: optional string artifact_sha256 = 8;
   */
  artifactSha256?: string;

  /**
   * @generated from field: optional int64 artifact_byte_size = 9;
   */
  artifactByteSize?: bigint;
};

/**
 * @generated from message guardianai.v1.distro.CreateReleaseJobRequest
 */
export type CreateReleaseJobRequestJson = {
  /**
   * @generated from field: string app_name = 1;
   */
  appName?: string;

  /**
   * @generated from field: repeated string platform_targets = 2;
   */
  platformTargets?: string[];

  /**
   * @generated from field: string release_track = 3;
   */
  releaseTrack?: string;

  /**
   * @generated from field: int32 rollout_percentage = 4;
   */
  rolloutPercentage?: number;

  /**
   * @generated from field: string release_version = 5;
   */
  releaseVersion?: string;

  /**
   * @generated from field: string build_artifact_uri = 6;
   */
  buildArtifactUri?: string;

  /**
   * @generated from field: string idempotency_key = 7;
   */
  idempotencyKey?: string;

  /**
   * @generated from field: optional string artifact_sha256 = 8;
   */
  artifactSha256?: string;

  /**
   * @generated from field: optional int64 artifact_byte_size = 9;
   */
  artifactByteSize?: string;
};

/**
 * Describes the message guardianai.v1.distro.CreateReleaseJobRequest.
 * Use `create(CreateReleaseJobRequestSchema)` to create a new message.
 */
export const CreateReleaseJobRequestSchema: GenMessage<CreateReleaseJobRequest, {jsonType: CreateReleaseJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 27);

/**
 * @generated from message guardianai.v1.distro.ReleaseJobResponse
 */
export type ReleaseJobResponse = Message<"guardianai.v1.distro.ReleaseJobResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroReleaseJob job = 1;
   */
  job?: DistroReleaseJob;
};

/**
 * @generated from message guardianai.v1.distro.ReleaseJobResponse
 */
export type ReleaseJobResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroReleaseJob job = 1;
   */
  job?: DistroReleaseJobJson;
};

/**
 * Describes the message guardianai.v1.distro.ReleaseJobResponse.
 * Use `create(ReleaseJobResponseSchema)` to create a new message.
 */
export const ReleaseJobResponseSchema: GenMessage<ReleaseJobResponse, {jsonType: ReleaseJobResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 28);

/**
 * @generated from message guardianai.v1.distro.GetReleaseJobRequest
 */
export type GetReleaseJobRequest = Message<"guardianai.v1.distro.GetReleaseJobRequest"> & {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId: string;
};

/**
 * @generated from message guardianai.v1.distro.GetReleaseJobRequest
 */
export type GetReleaseJobRequestJson = {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId?: string;
};

/**
 * Describes the message guardianai.v1.distro.GetReleaseJobRequest.
 * Use `create(GetReleaseJobRequestSchema)` to create a new message.
 */
export const GetReleaseJobRequestSchema: GenMessage<GetReleaseJobRequest, {jsonType: GetReleaseJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 29);

/**
 * @generated from message guardianai.v1.distro.ListReleaseJobsRequest
 */
export type ListReleaseJobsRequest = Message<"guardianai.v1.distro.ListReleaseJobsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.distro.ListReleaseJobsRequest
 */
export type ListReleaseJobsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListReleaseJobsRequest.
 * Use `create(ListReleaseJobsRequestSchema)` to create a new message.
 */
export const ListReleaseJobsRequestSchema: GenMessage<ListReleaseJobsRequest, {jsonType: ListReleaseJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 30);

/**
 * @generated from message guardianai.v1.distro.ListReleaseJobsResponse
 */
export type ListReleaseJobsResponse = Message<"guardianai.v1.distro.ListReleaseJobsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroReleaseJob jobs = 1;
   */
  jobs: DistroReleaseJob[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.ListReleaseJobsResponse
 */
export type ListReleaseJobsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroReleaseJob jobs = 1;
   */
  jobs?: DistroReleaseJobJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListReleaseJobsResponse.
 * Use `create(ListReleaseJobsResponseSchema)` to create a new message.
 */
export const ListReleaseJobsResponseSchema: GenMessage<ListReleaseJobsResponse, {jsonType: ListReleaseJobsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 31);

/**
 * @generated from message guardianai.v1.distro.RetryReleaseJobRequest
 */
export type RetryReleaseJobRequest = Message<"guardianai.v1.distro.RetryReleaseJobRequest"> & {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId: string;
};

/**
 * @generated from message guardianai.v1.distro.RetryReleaseJobRequest
 */
export type RetryReleaseJobRequestJson = {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId?: string;
};

/**
 * Describes the message guardianai.v1.distro.RetryReleaseJobRequest.
 * Use `create(RetryReleaseJobRequestSchema)` to create a new message.
 */
export const RetryReleaseJobRequestSchema: GenMessage<RetryReleaseJobRequest, {jsonType: RetryReleaseJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 32);

/**
 * @generated from message guardianai.v1.distro.CancelReleaseJobRequest
 */
export type CancelReleaseJobRequest = Message<"guardianai.v1.distro.CancelReleaseJobRequest"> & {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId: string;

  /**
   * @generated from field: string reason_code = 2;
   */
  reasonCode: string;
};

/**
 * @generated from message guardianai.v1.distro.CancelReleaseJobRequest
 */
export type CancelReleaseJobRequestJson = {
  /**
   * @generated from field: string release_job_id = 1;
   */
  releaseJobId?: string;

  /**
   * @generated from field: string reason_code = 2;
   */
  reasonCode?: string;
};

/**
 * Describes the message guardianai.v1.distro.CancelReleaseJobRequest.
 * Use `create(CancelReleaseJobRequestSchema)` to create a new message.
 */
export const CancelReleaseJobRequestSchema: GenMessage<CancelReleaseJobRequest, {jsonType: CancelReleaseJobRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 33);

/**
 * @generated from message guardianai.v1.distro.DistroStoreConnection
 */
export type DistroStoreConnection = Message<"guardianai.v1.distro.DistroStoreConnection"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string store_key = 2;
   */
  storeKey: string;

  /**
   * @generated from field: string external_account_id = 3;
   */
  externalAccountId: string;

  /**
   * @generated from field: bool is_active = 4;
   */
  isActive: boolean;

  /**
   * @generated from field: string credentials_ref = 5;
   */
  credentialsRef: string;

  /**
   * @generated from field: string last_validated_at = 6;
   */
  lastValidatedAt: string;

  /**
   * @generated from field: string purged_at = 7;
   */
  purgedAt: string;

  /**
   * @generated from field: string latest_job_status = 8;
   */
  latestJobStatus: string;
};

/**
 * @generated from message guardianai.v1.distro.DistroStoreConnection
 */
export type DistroStoreConnectionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string store_key = 2;
   */
  storeKey?: string;

  /**
   * @generated from field: string external_account_id = 3;
   */
  externalAccountId?: string;

  /**
   * @generated from field: bool is_active = 4;
   */
  isActive?: boolean;

  /**
   * @generated from field: string credentials_ref = 5;
   */
  credentialsRef?: string;

  /**
   * @generated from field: string last_validated_at = 6;
   */
  lastValidatedAt?: string;

  /**
   * @generated from field: string purged_at = 7;
   */
  purgedAt?: string;

  /**
   * @generated from field: string latest_job_status = 8;
   */
  latestJobStatus?: string;
};

/**
 * Describes the message guardianai.v1.distro.DistroStoreConnection.
 * Use `create(DistroStoreConnectionSchema)` to create a new message.
 */
export const DistroStoreConnectionSchema: GenMessage<DistroStoreConnection, {jsonType: DistroStoreConnectionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 34);

/**
 * @generated from message guardianai.v1.distro.UpsertStoreConnectionRequest
 */
export type UpsertStoreConnectionRequest = Message<"guardianai.v1.distro.UpsertStoreConnectionRequest"> & {
  /**
   * @generated from field: string store_key = 1;
   */
  storeKey: string;

  /**
   * @generated from field: string external_account_id = 2;
   */
  externalAccountId: string;

  /**
   * @generated from field: bool is_active = 3;
   */
  isActive: boolean;

  /**
   * @generated from field: string credentials_ref = 4;
   */
  credentialsRef: string;
};

/**
 * @generated from message guardianai.v1.distro.UpsertStoreConnectionRequest
 */
export type UpsertStoreConnectionRequestJson = {
  /**
   * @generated from field: string store_key = 1;
   */
  storeKey?: string;

  /**
   * @generated from field: string external_account_id = 2;
   */
  externalAccountId?: string;

  /**
   * @generated from field: bool is_active = 3;
   */
  isActive?: boolean;

  /**
   * @generated from field: string credentials_ref = 4;
   */
  credentialsRef?: string;
};

/**
 * Describes the message guardianai.v1.distro.UpsertStoreConnectionRequest.
 * Use `create(UpsertStoreConnectionRequestSchema)` to create a new message.
 */
export const UpsertStoreConnectionRequestSchema: GenMessage<UpsertStoreConnectionRequest, {jsonType: UpsertStoreConnectionRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 35);

/**
 * @generated from message guardianai.v1.distro.UpsertStoreConnectionResponse
 */
export type UpsertStoreConnectionResponse = Message<"guardianai.v1.distro.UpsertStoreConnectionResponse"> & {
  /**
   * @generated from field: guardianai.v1.distro.DistroStoreConnection connection = 1;
   */
  connection?: DistroStoreConnection;
};

/**
 * @generated from message guardianai.v1.distro.UpsertStoreConnectionResponse
 */
export type UpsertStoreConnectionResponseJson = {
  /**
   * @generated from field: guardianai.v1.distro.DistroStoreConnection connection = 1;
   */
  connection?: DistroStoreConnectionJson;
};

/**
 * Describes the message guardianai.v1.distro.UpsertStoreConnectionResponse.
 * Use `create(UpsertStoreConnectionResponseSchema)` to create a new message.
 */
export const UpsertStoreConnectionResponseSchema: GenMessage<UpsertStoreConnectionResponse, {jsonType: UpsertStoreConnectionResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 36);

/**
 * @generated from message guardianai.v1.distro.ListStoreConnectionsRequest
 */
export type ListStoreConnectionsRequest = Message<"guardianai.v1.distro.ListStoreConnectionsRequest"> & {
};

/**
 * @generated from message guardianai.v1.distro.ListStoreConnectionsRequest
 */
export type ListStoreConnectionsRequestJson = {
};

/**
 * Describes the message guardianai.v1.distro.ListStoreConnectionsRequest.
 * Use `create(ListStoreConnectionsRequestSchema)` to create a new message.
 */
export const ListStoreConnectionsRequestSchema: GenMessage<ListStoreConnectionsRequest, {jsonType: ListStoreConnectionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 37);

/**
 * @generated from message guardianai.v1.distro.ListStoreConnectionsResponse
 */
export type ListStoreConnectionsResponse = Message<"guardianai.v1.distro.ListStoreConnectionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroStoreConnection connections = 1;
   */
  connections: DistroStoreConnection[];
};

/**
 * @generated from message guardianai.v1.distro.ListStoreConnectionsResponse
 */
export type ListStoreConnectionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroStoreConnection connections = 1;
   */
  connections?: DistroStoreConnectionJson[];
};

/**
 * Describes the message guardianai.v1.distro.ListStoreConnectionsResponse.
 * Use `create(ListStoreConnectionsResponseSchema)` to create a new message.
 */
export const ListStoreConnectionsResponseSchema: GenMessage<ListStoreConnectionsResponse, {jsonType: ListStoreConnectionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 38);

/**
 * @generated from message guardianai.v1.distro.PurgeCredentialsRequest
 */
export type PurgeCredentialsRequest = Message<"guardianai.v1.distro.PurgeCredentialsRequest"> & {
  /**
   * @generated from field: string reason_code = 1;
   */
  reasonCode: string;
};

/**
 * @generated from message guardianai.v1.distro.PurgeCredentialsRequest
 */
export type PurgeCredentialsRequestJson = {
  /**
   * @generated from field: string reason_code = 1;
   */
  reasonCode?: string;
};

/**
 * Describes the message guardianai.v1.distro.PurgeCredentialsRequest.
 * Use `create(PurgeCredentialsRequestSchema)` to create a new message.
 */
export const PurgeCredentialsRequestSchema: GenMessage<PurgeCredentialsRequest, {jsonType: PurgeCredentialsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 39);

/**
 * @generated from message guardianai.v1.distro.PurgeCredentialsResponse
 */
export type PurgeCredentialsResponse = Message<"guardianai.v1.distro.PurgeCredentialsResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string purged_at = 2;
   */
  purgedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.PurgeCredentialsResponse
 */
export type PurgeCredentialsResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string purged_at = 2;
   */
  purgedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.PurgeCredentialsResponse.
 * Use `create(PurgeCredentialsResponseSchema)` to create a new message.
 */
export const PurgeCredentialsResponseSchema: GenMessage<PurgeCredentialsResponse, {jsonType: PurgeCredentialsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 40);

/**
 * @generated from message guardianai.v1.distro.GenerateMetadataRequest
 */
export type GenerateMetadataRequest = Message<"guardianai.v1.distro.GenerateMetadataRequest"> & {
  /**
   * @generated from field: string app_description = 1;
   */
  appDescription: string;
};

/**
 * @generated from message guardianai.v1.distro.GenerateMetadataRequest
 */
export type GenerateMetadataRequestJson = {
  /**
   * @generated from field: string app_description = 1;
   */
  appDescription?: string;
};

/**
 * Describes the message guardianai.v1.distro.GenerateMetadataRequest.
 * Use `create(GenerateMetadataRequestSchema)` to create a new message.
 */
export const GenerateMetadataRequestSchema: GenMessage<GenerateMetadataRequest, {jsonType: GenerateMetadataRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 41);

/**
 * @generated from message guardianai.v1.distro.GenerateMetadataResponse
 */
export type GenerateMetadataResponse = Message<"guardianai.v1.distro.GenerateMetadataResponse"> & {
  /**
   * @generated from field: string app_store_description = 1;
   */
  appStoreDescription: string;

  /**
   * @generated from field: string play_store_description = 2;
   */
  playStoreDescription: string;

  /**
   * @generated from field: string release_notes = 3;
   */
  releaseNotes: string;

  /**
   * @generated from field: repeated string title_variants = 4;
   */
  titleVariants: string[];

  /**
   * @generated from field: repeated string short_description_variants = 5;
   */
  shortDescriptionVariants: string[];
};

/**
 * @generated from message guardianai.v1.distro.GenerateMetadataResponse
 */
export type GenerateMetadataResponseJson = {
  /**
   * @generated from field: string app_store_description = 1;
   */
  appStoreDescription?: string;

  /**
   * @generated from field: string play_store_description = 2;
   */
  playStoreDescription?: string;

  /**
   * @generated from field: string release_notes = 3;
   */
  releaseNotes?: string;

  /**
   * @generated from field: repeated string title_variants = 4;
   */
  titleVariants?: string[];

  /**
   * @generated from field: repeated string short_description_variants = 5;
   */
  shortDescriptionVariants?: string[];
};

/**
 * Describes the message guardianai.v1.distro.GenerateMetadataResponse.
 * Use `create(GenerateMetadataResponseSchema)` to create a new message.
 */
export const GenerateMetadataResponseSchema: GenMessage<GenerateMetadataResponse, {jsonType: GenerateMetadataResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 42);

/**
 * @generated from message guardianai.v1.distro.CreateWaitlistPageRequest
 */
export type CreateWaitlistPageRequest = Message<"guardianai.v1.distro.CreateWaitlistPageRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string hero_text = 3;
   */
  heroText: string;

  /**
   * @generated from field: string email_provider = 4;
   */
  emailProvider: string;

  /**
   * @generated from field: string provider_audience_ref = 5;
   */
  providerAudienceRef: string;
};

/**
 * @generated from message guardianai.v1.distro.CreateWaitlistPageRequest
 */
export type CreateWaitlistPageRequestJson = {
  /**
   * @generated from field: string slug = 1;
   */
  slug?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string hero_text = 3;
   */
  heroText?: string;

  /**
   * @generated from field: string email_provider = 4;
   */
  emailProvider?: string;

  /**
   * @generated from field: string provider_audience_ref = 5;
   */
  providerAudienceRef?: string;
};

/**
 * Describes the message guardianai.v1.distro.CreateWaitlistPageRequest.
 * Use `create(CreateWaitlistPageRequestSchema)` to create a new message.
 */
export const CreateWaitlistPageRequestSchema: GenMessage<CreateWaitlistPageRequest, {jsonType: CreateWaitlistPageRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 43);

/**
 * @generated from message guardianai.v1.distro.WaitlistPageResponse
 */
export type WaitlistPageResponse = Message<"guardianai.v1.distro.WaitlistPageResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string hero_text = 4;
   */
  heroText: string;

  /**
   * @generated from field: string email_provider = 5;
   */
  emailProvider: string;

  /**
   * @generated from field: string provider_audience_ref = 6;
   */
  providerAudienceRef: string;

  /**
   * @generated from field: bool is_published = 7;
   */
  isPublished: boolean;

  /**
   * @generated from field: string public_url = 8;
   */
  publicUrl: string;
};

/**
 * @generated from message guardianai.v1.distro.WaitlistPageResponse
 */
export type WaitlistPageResponseJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string hero_text = 4;
   */
  heroText?: string;

  /**
   * @generated from field: string email_provider = 5;
   */
  emailProvider?: string;

  /**
   * @generated from field: string provider_audience_ref = 6;
   */
  providerAudienceRef?: string;

  /**
   * @generated from field: bool is_published = 7;
   */
  isPublished?: boolean;

  /**
   * @generated from field: string public_url = 8;
   */
  publicUrl?: string;
};

/**
 * Describes the message guardianai.v1.distro.WaitlistPageResponse.
 * Use `create(WaitlistPageResponseSchema)` to create a new message.
 */
export const WaitlistPageResponseSchema: GenMessage<WaitlistPageResponse, {jsonType: WaitlistPageResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 44);

/**
 * @generated from message guardianai.v1.distro.ScorePositioningRequest
 */
export type ScorePositioningRequest = Message<"guardianai.v1.distro.ScorePositioningRequest"> & {
  /**
   * @generated from field: string pitch_text = 1;
   */
  pitchText: string;
};

/**
 * @generated from message guardianai.v1.distro.ScorePositioningRequest
 */
export type ScorePositioningRequestJson = {
  /**
   * @generated from field: string pitch_text = 1;
   */
  pitchText?: string;
};

/**
 * Describes the message guardianai.v1.distro.ScorePositioningRequest.
 * Use `create(ScorePositioningRequestSchema)` to create a new message.
 */
export const ScorePositioningRequestSchema: GenMessage<ScorePositioningRequest, {jsonType: ScorePositioningRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 45);

/**
 * @generated from message guardianai.v1.distro.ScorePositioningResponse
 */
export type ScorePositioningResponse = Message<"guardianai.v1.distro.ScorePositioningResponse"> & {
  /**
   * @generated from field: int32 score = 1;
   */
  score: number;

  /**
   * @generated from field: repeated string missing_elements = 2;
   */
  missingElements: string[];

  /**
   * @generated from field: string competitor_summary_json = 3;
   */
  competitorSummaryJson: string;

  /**
   * @generated from field: repeated string recommended_channels = 4;
   */
  recommendedChannels: string[];

  /**
   * @generated from field: string channel_fit_analysis_mode = 5;
   */
  channelFitAnalysisMode: string;
};

/**
 * @generated from message guardianai.v1.distro.ScorePositioningResponse
 */
export type ScorePositioningResponseJson = {
  /**
   * @generated from field: int32 score = 1;
   */
  score?: number;

  /**
   * @generated from field: repeated string missing_elements = 2;
   */
  missingElements?: string[];

  /**
   * @generated from field: string competitor_summary_json = 3;
   */
  competitorSummaryJson?: string;

  /**
   * @generated from field: repeated string recommended_channels = 4;
   */
  recommendedChannels?: string[];

  /**
   * @generated from field: string channel_fit_analysis_mode = 5;
   */
  channelFitAnalysisMode?: string;
};

/**
 * Describes the message guardianai.v1.distro.ScorePositioningResponse.
 * Use `create(ScorePositioningResponseSchema)` to create a new message.
 */
export const ScorePositioningResponseSchema: GenMessage<ScorePositioningResponse, {jsonType: ScorePositioningResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 46);

/**
 * @generated from message guardianai.v1.distro.RecordAttributionEventRequest
 */
export type RecordAttributionEventRequest = Message<"guardianai.v1.distro.RecordAttributionEventRequest"> & {
  /**
   * @generated from field: string campaign_source = 1;
   */
  campaignSource: string;

  /**
   * @generated from field: string event_type = 2;
   */
  eventType: string;

  /**
   * @generated from field: int64 event_value_cents = 3;
   */
  eventValueCents: bigint;

  /**
   * @generated from field: string stripe_customer_id = 4;
   */
  stripeCustomerId: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId: string;
};

/**
 * @generated from message guardianai.v1.distro.RecordAttributionEventRequest
 */
export type RecordAttributionEventRequestJson = {
  /**
   * @generated from field: string campaign_source = 1;
   */
  campaignSource?: string;

  /**
   * @generated from field: string event_type = 2;
   */
  eventType?: string;

  /**
   * @generated from field: int64 event_value_cents = 3;
   */
  eventValueCents?: string;

  /**
   * @generated from field: string stripe_customer_id = 4;
   */
  stripeCustomerId?: string;

  /**
   * @generated from field: string stripe_payment_intent_id = 5;
   */
  stripePaymentIntentId?: string;
};

/**
 * Describes the message guardianai.v1.distro.RecordAttributionEventRequest.
 * Use `create(RecordAttributionEventRequestSchema)` to create a new message.
 */
export const RecordAttributionEventRequestSchema: GenMessage<RecordAttributionEventRequest, {jsonType: RecordAttributionEventRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 47);

/**
 * @generated from message guardianai.v1.distro.RecordAttributionEventResponse
 */
export type RecordAttributionEventResponse = Message<"guardianai.v1.distro.RecordAttributionEventResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * @generated from message guardianai.v1.distro.RecordAttributionEventResponse
 */
export type RecordAttributionEventResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;
};

/**
 * Describes the message guardianai.v1.distro.RecordAttributionEventResponse.
 * Use `create(RecordAttributionEventResponseSchema)` to create a new message.
 */
export const RecordAttributionEventResponseSchema: GenMessage<RecordAttributionEventResponse, {jsonType: RecordAttributionEventResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 48);

/**
 * @generated from message guardianai.v1.distro.GetAttributionSummaryRequest
 */
export type GetAttributionSummaryRequest = Message<"guardianai.v1.distro.GetAttributionSummaryRequest"> & {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm: string;
};

/**
 * @generated from message guardianai.v1.distro.GetAttributionSummaryRequest
 */
export type GetAttributionSummaryRequestJson = {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm?: string;
};

/**
 * Describes the message guardianai.v1.distro.GetAttributionSummaryRequest.
 * Use `create(GetAttributionSummaryRequestSchema)` to create a new message.
 */
export const GetAttributionSummaryRequestSchema: GenMessage<GetAttributionSummaryRequest, {jsonType: GetAttributionSummaryRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 49);

/**
 * @generated from message guardianai.v1.distro.GetAttributionSummaryResponse
 */
export type GetAttributionSummaryResponse = Message<"guardianai.v1.distro.GetAttributionSummaryResponse"> & {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm: string;

  /**
   * @generated from field: int64 total_revenue_cents = 2;
   */
  totalRevenueCents: bigint;

  /**
   * @generated from field: int64 new_paying_users = 3;
   */
  newPayingUsers: bigint;

  /**
   * @generated from field: int64 attributed_events = 4;
   */
  attributedEvents: bigint;

  /**
   * @generated from field: int64 cac_cents = 5;
   */
  cacCents: bigint;

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.GetAttributionSummaryResponse
 */
export type GetAttributionSummaryResponseJson = {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm?: string;

  /**
   * @generated from field: int64 total_revenue_cents = 2;
   */
  totalRevenueCents?: string;

  /**
   * @generated from field: int64 new_paying_users = 3;
   */
  newPayingUsers?: string;

  /**
   * @generated from field: int64 attributed_events = 4;
   */
  attributedEvents?: string;

  /**
   * @generated from field: int64 cac_cents = 5;
   */
  cacCents?: string;

  /**
   * @generated from field: string generated_at = 6;
   */
  generatedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.GetAttributionSummaryResponse.
 * Use `create(GetAttributionSummaryResponseSchema)` to create a new message.
 */
export const GetAttributionSummaryResponseSchema: GenMessage<GetAttributionSummaryResponse, {jsonType: GetAttributionSummaryResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 50);

/**
 * @generated from message guardianai.v1.distro.GenerateMonthlyReportRequest
 */
export type GenerateMonthlyReportRequest = Message<"guardianai.v1.distro.GenerateMonthlyReportRequest"> & {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm: string;
};

/**
 * @generated from message guardianai.v1.distro.GenerateMonthlyReportRequest
 */
export type GenerateMonthlyReportRequestJson = {
  /**
   * @generated from field: string period_yyyy_mm = 1;
   */
  periodYyyyMm?: string;
};

/**
 * Describes the message guardianai.v1.distro.GenerateMonthlyReportRequest.
 * Use `create(GenerateMonthlyReportRequestSchema)` to create a new message.
 */
export const GenerateMonthlyReportRequestSchema: GenMessage<GenerateMonthlyReportRequest, {jsonType: GenerateMonthlyReportRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 51);

/**
 * @generated from message guardianai.v1.distro.GenerateMonthlyReportResponse
 */
export type GenerateMonthlyReportResponse = Message<"guardianai.v1.distro.GenerateMonthlyReportResponse"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string period_yyyy_mm = 2;
   */
  periodYyyyMm: string;

  /**
   * @generated from field: int64 total_revenue_cents = 3;
   */
  totalRevenueCents: bigint;

  /**
   * @generated from field: int64 new_paying_users = 4;
   */
  newPayingUsers: bigint;

  /**
   * @generated from field: int64 attributed_events = 5;
   */
  attributedEvents: bigint;

  /**
   * @generated from field: int64 cac_cents = 6;
   */
  cacCents: bigint;

  /**
   * @generated from field: int32 data_version = 7;
   */
  dataVersion: number;

  /**
   * @generated from field: string generated_at = 8;
   */
  generatedAt: string;
};

/**
 * @generated from message guardianai.v1.distro.GenerateMonthlyReportResponse
 */
export type GenerateMonthlyReportResponseJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string period_yyyy_mm = 2;
   */
  periodYyyyMm?: string;

  /**
   * @generated from field: int64 total_revenue_cents = 3;
   */
  totalRevenueCents?: string;

  /**
   * @generated from field: int64 new_paying_users = 4;
   */
  newPayingUsers?: string;

  /**
   * @generated from field: int64 attributed_events = 5;
   */
  attributedEvents?: string;

  /**
   * @generated from field: int64 cac_cents = 6;
   */
  cacCents?: string;

  /**
   * @generated from field: int32 data_version = 7;
   */
  dataVersion?: number;

  /**
   * @generated from field: string generated_at = 8;
   */
  generatedAt?: string;
};

/**
 * Describes the message guardianai.v1.distro.GenerateMonthlyReportResponse.
 * Use `create(GenerateMonthlyReportResponseSchema)` to create a new message.
 */
export const GenerateMonthlyReportResponseSchema: GenMessage<GenerateMonthlyReportResponse, {jsonType: GenerateMonthlyReportResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 52);

/**
 * @generated from message guardianai.v1.distro.MatchAgentProfilesRequest
 */
export type MatchAgentProfilesRequest = Message<"guardianai.v1.distro.MatchAgentProfilesRequest"> & {
  /**
   * @generated from field: string product_slug = 1;
   */
  productSlug: string;

  /**
   * @generated from field: string audience_profile_json = 2;
   */
  audienceProfileJson: string;
};

/**
 * @generated from message guardianai.v1.distro.MatchAgentProfilesRequest
 */
export type MatchAgentProfilesRequestJson = {
  /**
   * @generated from field: string product_slug = 1;
   */
  productSlug?: string;

  /**
   * @generated from field: string audience_profile_json = 2;
   */
  audienceProfileJson?: string;
};

/**
 * Describes the message guardianai.v1.distro.MatchAgentProfilesRequest.
 * Use `create(MatchAgentProfilesRequestSchema)` to create a new message.
 */
export const MatchAgentProfilesRequestSchema: GenMessage<MatchAgentProfilesRequest, {jsonType: MatchAgentProfilesRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 53);

/**
 * @generated from message guardianai.v1.distro.AgentMatchResult
 */
export type AgentMatchResult = Message<"guardianai.v1.distro.AgentMatchResult"> & {
  /**
   * @generated from field: string sales_agent_id = 1;
   */
  salesAgentId: string;

  /**
   * @generated from field: double score = 2;
   */
  score: number;

  /**
   * @generated from field: string score_reason = 3;
   */
  scoreReason: string;
};

/**
 * @generated from message guardianai.v1.distro.AgentMatchResult
 */
export type AgentMatchResultJson = {
  /**
   * @generated from field: string sales_agent_id = 1;
   */
  salesAgentId?: string;

  /**
   * @generated from field: double score = 2;
   */
  score?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: string score_reason = 3;
   */
  scoreReason?: string;
};

/**
 * Describes the message guardianai.v1.distro.AgentMatchResult.
 * Use `create(AgentMatchResultSchema)` to create a new message.
 */
export const AgentMatchResultSchema: GenMessage<AgentMatchResult, {jsonType: AgentMatchResultJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 54);

/**
 * @generated from message guardianai.v1.distro.AdminListReleaseJobsRequest
 */
export type AdminListReleaseJobsRequest = Message<"guardianai.v1.distro.AdminListReleaseJobsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;
};

/**
 * @generated from message guardianai.v1.distro.AdminListReleaseJobsRequest
 */
export type AdminListReleaseJobsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;
};

/**
 * Describes the message guardianai.v1.distro.AdminListReleaseJobsRequest.
 * Use `create(AdminListReleaseJobsRequestSchema)` to create a new message.
 */
export const AdminListReleaseJobsRequestSchema: GenMessage<AdminListReleaseJobsRequest, {jsonType: AdminListReleaseJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 55);

/**
 * @generated from message guardianai.v1.distro.AdminListReleaseJobsResponse
 */
export type AdminListReleaseJobsResponse = Message<"guardianai.v1.distro.AdminListReleaseJobsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroReleaseJob jobs = 1;
   */
  jobs: DistroReleaseJob[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.AdminListReleaseJobsResponse
 */
export type AdminListReleaseJobsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroReleaseJob jobs = 1;
   */
  jobs?: DistroReleaseJobJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.AdminListReleaseJobsResponse.
 * Use `create(AdminListReleaseJobsResponseSchema)` to create a new message.
 */
export const AdminListReleaseJobsResponseSchema: GenMessage<AdminListReleaseJobsResponse, {jsonType: AdminListReleaseJobsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 56);

/**
 * @generated from message guardianai.v1.distro.AdminListWhiteGloveEngagementsRequest
 */
export type AdminListWhiteGloveEngagementsRequest = Message<"guardianai.v1.distro.AdminListWhiteGloveEngagementsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;
};

/**
 * @generated from message guardianai.v1.distro.AdminListWhiteGloveEngagementsRequest
 */
export type AdminListWhiteGloveEngagementsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;
};

/**
 * Describes the message guardianai.v1.distro.AdminListWhiteGloveEngagementsRequest.
 * Use `create(AdminListWhiteGloveEngagementsRequestSchema)` to create a new message.
 */
export const AdminListWhiteGloveEngagementsRequestSchema: GenMessage<AdminListWhiteGloveEngagementsRequest, {jsonType: AdminListWhiteGloveEngagementsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 57);

/**
 * @generated from message guardianai.v1.distro.AdminListWhiteGloveEngagementsResponse
 */
export type AdminListWhiteGloveEngagementsResponse = Message<"guardianai.v1.distro.AdminListWhiteGloveEngagementsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroWhiteGloveEngagement engagements = 1;
   */
  engagements: DistroWhiteGloveEngagement[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.AdminListWhiteGloveEngagementsResponse
 */
export type AdminListWhiteGloveEngagementsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DistroWhiteGloveEngagement engagements = 1;
   */
  engagements?: DistroWhiteGloveEngagementJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.AdminListWhiteGloveEngagementsResponse.
 * Use `create(AdminListWhiteGloveEngagementsResponseSchema)` to create a new message.
 */
export const AdminListWhiteGloveEngagementsResponseSchema: GenMessage<AdminListWhiteGloveEngagementsResponse, {jsonType: AdminListWhiteGloveEngagementsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 58);

/**
 * @generated from message guardianai.v1.distro.AdminGetDistroFleetMetricsRequest
 */
export type AdminGetDistroFleetMetricsRequest = Message<"guardianai.v1.distro.AdminGetDistroFleetMetricsRequest"> & {
};

/**
 * @generated from message guardianai.v1.distro.AdminGetDistroFleetMetricsRequest
 */
export type AdminGetDistroFleetMetricsRequestJson = {
};

/**
 * Describes the message guardianai.v1.distro.AdminGetDistroFleetMetricsRequest.
 * Use `create(AdminGetDistroFleetMetricsRequestSchema)` to create a new message.
 */
export const AdminGetDistroFleetMetricsRequestSchema: GenMessage<AdminGetDistroFleetMetricsRequest, {jsonType: AdminGetDistroFleetMetricsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 59);

/**
 * @generated from message guardianai.v1.distro.AdminGetDistroFleetMetricsResponse
 */
export type AdminGetDistroFleetMetricsResponse = Message<"guardianai.v1.distro.AdminGetDistroFleetMetricsResponse"> & {
  /**
   * @generated from field: int32 total_store_connections = 3;
   */
  totalStoreConnections: number;

  /**
   * @generated from field: int32 unhealthy_store_connections = 4;
   */
  unhealthyStoreConnections: number;

  /**
   * @generated from field: int32 active_release_jobs = 5;
   */
  activeReleaseJobs: number;

  /**
   * @generated from field: int32 pending_white_glove_requests = 6;
   */
  pendingWhiteGloveRequests: number;
};

/**
 * @generated from message guardianai.v1.distro.AdminGetDistroFleetMetricsResponse
 */
export type AdminGetDistroFleetMetricsResponseJson = {
  /**
   * @generated from field: int32 total_store_connections = 3;
   */
  totalStoreConnections?: number;

  /**
   * @generated from field: int32 unhealthy_store_connections = 4;
   */
  unhealthyStoreConnections?: number;

  /**
   * @generated from field: int32 active_release_jobs = 5;
   */
  activeReleaseJobs?: number;

  /**
   * @generated from field: int32 pending_white_glove_requests = 6;
   */
  pendingWhiteGloveRequests?: number;
};

/**
 * Describes the message guardianai.v1.distro.AdminGetDistroFleetMetricsResponse.
 * Use `create(AdminGetDistroFleetMetricsResponseSchema)` to create a new message.
 */
export const AdminGetDistroFleetMetricsResponseSchema: GenMessage<AdminGetDistroFleetMetricsResponse, {jsonType: AdminGetDistroFleetMetricsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 60);

/**
 * @generated from message guardianai.v1.distro.SocialLead
 */
export type SocialLead = Message<"guardianai.v1.distro.SocialLead"> & {
  /**
   * @generated from field: string lead_id = 1;
   */
  leadId: string;

  /**
   * @generated from field: string keyword_matched = 2;
   */
  keywordMatched: string;

  /**
   * @generated from field: string author_handle = 3;
   */
  authorHandle: string;

  /**
   * @generated from field: string snippet = 4;
   */
  snippet: string;

  /**
   * @generated from field: string source_platform = 5;
   */
  sourcePlatform: string;

  /**
   * @generated from field: string source_url = 6;
   */
  sourceUrl: string;

  /**
   * @generated from field: string detected_at = 7;
   */
  detectedAt: string;

  /**
   * @generated from field: string sentiment = 8;
   */
  sentiment: string;
};

/**
 * @generated from message guardianai.v1.distro.SocialLead
 */
export type SocialLeadJson = {
  /**
   * @generated from field: string lead_id = 1;
   */
  leadId?: string;

  /**
   * @generated from field: string keyword_matched = 2;
   */
  keywordMatched?: string;

  /**
   * @generated from field: string author_handle = 3;
   */
  authorHandle?: string;

  /**
   * @generated from field: string snippet = 4;
   */
  snippet?: string;

  /**
   * @generated from field: string source_platform = 5;
   */
  sourcePlatform?: string;

  /**
   * @generated from field: string source_url = 6;
   */
  sourceUrl?: string;

  /**
   * @generated from field: string detected_at = 7;
   */
  detectedAt?: string;

  /**
   * @generated from field: string sentiment = 8;
   */
  sentiment?: string;
};

/**
 * Describes the message guardianai.v1.distro.SocialLead.
 * Use `create(SocialLeadSchema)` to create a new message.
 */
export const SocialLeadSchema: GenMessage<SocialLead, {jsonType: SocialLeadJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 61);

/**
 * @generated from message guardianai.v1.distro.ListSocialLeadsRequest
 */
export type ListSocialLeadsRequest = Message<"guardianai.v1.distro.ListSocialLeadsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.distro.ListSocialLeadsRequest
 */
export type ListSocialLeadsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListSocialLeadsRequest.
 * Use `create(ListSocialLeadsRequestSchema)` to create a new message.
 */
export const ListSocialLeadsRequestSchema: GenMessage<ListSocialLeadsRequest, {jsonType: ListSocialLeadsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 62);

/**
 * @generated from message guardianai.v1.distro.ListSocialLeadsResponse
 */
export type ListSocialLeadsResponse = Message<"guardianai.v1.distro.ListSocialLeadsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.SocialLead leads = 1;
   */
  leads: SocialLead[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.ListSocialLeadsResponse
 */
export type ListSocialLeadsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.SocialLead leads = 1;
   */
  leads?: SocialLeadJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListSocialLeadsResponse.
 * Use `create(ListSocialLeadsResponseSchema)` to create a new message.
 */
export const ListSocialLeadsResponseSchema: GenMessage<ListSocialLeadsResponse, {jsonType: ListSocialLeadsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 63);

/**
 * @generated from message guardianai.v1.distro.DirectorySubmission
 */
export type DirectorySubmission = Message<"guardianai.v1.distro.DirectorySubmission"> & {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId: string;

  /**
   * @generated from field: string directory_name = 2;
   */
  directoryName: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string submission_url = 4;
   */
  submissionUrl: string;

  /**
   * @generated from field: string submitted_at = 5;
   */
  submittedAt: string;

  /**
   * @generated from field: string feedback_notes = 6;
   */
  feedbackNotes: string;
};

/**
 * @generated from message guardianai.v1.distro.DirectorySubmission
 */
export type DirectorySubmissionJson = {
  /**
   * @generated from field: string submission_id = 1;
   */
  submissionId?: string;

  /**
   * @generated from field: string directory_name = 2;
   */
  directoryName?: string;

  /**
   * @generated from field: string status = 3;
   */
  status?: string;

  /**
   * @generated from field: string submission_url = 4;
   */
  submissionUrl?: string;

  /**
   * @generated from field: string submitted_at = 5;
   */
  submittedAt?: string;

  /**
   * @generated from field: string feedback_notes = 6;
   */
  feedbackNotes?: string;
};

/**
 * Describes the message guardianai.v1.distro.DirectorySubmission.
 * Use `create(DirectorySubmissionSchema)` to create a new message.
 */
export const DirectorySubmissionSchema: GenMessage<DirectorySubmission, {jsonType: DirectorySubmissionJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 64);

/**
 * @generated from message guardianai.v1.distro.ListDirectorySubmissionsRequest
 */
export type ListDirectorySubmissionsRequest = Message<"guardianai.v1.distro.ListDirectorySubmissionsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.distro.ListDirectorySubmissionsRequest
 */
export type ListDirectorySubmissionsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListDirectorySubmissionsRequest.
 * Use `create(ListDirectorySubmissionsRequestSchema)` to create a new message.
 */
export const ListDirectorySubmissionsRequestSchema: GenMessage<ListDirectorySubmissionsRequest, {jsonType: ListDirectorySubmissionsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 65);

/**
 * @generated from message guardianai.v1.distro.ListDirectorySubmissionsResponse
 */
export type ListDirectorySubmissionsResponse = Message<"guardianai.v1.distro.ListDirectorySubmissionsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.DirectorySubmission submissions = 1;
   */
  submissions: DirectorySubmission[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.distro.ListDirectorySubmissionsResponse
 */
export type ListDirectorySubmissionsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.DirectorySubmission submissions = 1;
   */
  submissions?: DirectorySubmissionJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.distro.ListDirectorySubmissionsResponse.
 * Use `create(ListDirectorySubmissionsResponseSchema)` to create a new message.
 */
export const ListDirectorySubmissionsResponseSchema: GenMessage<ListDirectorySubmissionsResponse, {jsonType: ListDirectorySubmissionsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 66);

/**
 * @generated from message guardianai.v1.distro.AgentMatch
 */
export type AgentMatch = Message<"guardianai.v1.distro.AgentMatch"> & {
  /**
   * @generated from field: string sales_agent_id = 1;
   */
  salesAgentId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;

  /**
   * @generated from field: string score_reason = 4;
   */
  scoreReason: string;

  /**
   * @generated from field: double score = 5;
   */
  score: number;
};

/**
 * @generated from message guardianai.v1.distro.AgentMatch
 */
export type AgentMatchJson = {
  /**
   * @generated from field: string sales_agent_id = 1;
   */
  salesAgentId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl?: string;

  /**
   * @generated from field: string score_reason = 4;
   */
  scoreReason?: string;

  /**
   * @generated from field: double score = 5;
   */
  score?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message guardianai.v1.distro.AgentMatch.
 * Use `create(AgentMatchSchema)` to create a new message.
 */
export const AgentMatchSchema: GenMessage<AgentMatch, {jsonType: AgentMatchJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 67);

/**
 * @generated from message guardianai.v1.distro.MatchAgentProfilesResponse
 */
export type MatchAgentProfilesResponse = Message<"guardianai.v1.distro.MatchAgentProfilesResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.distro.AgentMatch matches = 1;
   */
  matches: AgentMatch[];
};

/**
 * @generated from message guardianai.v1.distro.MatchAgentProfilesResponse
 */
export type MatchAgentProfilesResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.distro.AgentMatch matches = 1;
   */
  matches?: AgentMatchJson[];
};

/**
 * Describes the message guardianai.v1.distro.MatchAgentProfilesResponse.
 * Use `create(MatchAgentProfilesResponseSchema)` to create a new message.
 */
export const MatchAgentProfilesResponseSchema: GenMessage<MatchAgentProfilesResponse, {jsonType: MatchAgentProfilesResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_distro_distro, 68);

/**
 * @generated from service guardianai.v1.distro.DistroEngineService
 */
export const DistroEngineService: GenService<{
  /**
   * Unit 1: Onboarding Engine
   *
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GetOnboardingChecklist
   */
  getOnboardingChecklist: {
    methodKind: "unary";
    input: typeof GetOnboardingChecklistRequestSchema;
    output: typeof GetOnboardingChecklistResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.UpdateChecklistItem
   */
  updateChecklistItem: {
    methodKind: "unary";
    input: typeof UpdateChecklistItemRequestSchema;
    output: typeof UpdateChecklistItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.RunCompliancePreflight
   */
  runCompliancePreflight: {
    methodKind: "unary";
    input: typeof RunCompliancePreflightRequestSchema;
    output: typeof RunCompliancePreflightResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListOnboardingActions
   */
  listOnboardingActions: {
    methodKind: "unary";
    input: typeof ListOnboardingActionsRequestSchema;
    output: typeof ListOnboardingActionsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ExecuteOnboardingAction
   */
  executeOnboardingAction: {
    methodKind: "unary";
    input: typeof ExecuteOnboardingActionRequestSchema;
    output: typeof ExecuteOnboardingActionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GetOnboardingActionOperation
   */
  getOnboardingActionOperation: {
    methodKind: "unary";
    input: typeof GetOnboardingActionOperationRequestSchema;
    output: typeof GetOnboardingActionOperationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListOnboardingActionOperations
   */
  listOnboardingActionOperations: {
    methodKind: "unary";
    input: typeof ListOnboardingActionOperationsRequestSchema;
    output: typeof ListOnboardingActionOperationsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.RequestWhiteGloveEngagement
   */
  requestWhiteGloveEngagement: {
    methodKind: "unary";
    input: typeof RequestWhiteGloveEngagementRequestSchema;
    output: typeof RequestWhiteGloveEngagementResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GetWhiteGloveEngagement
   */
  getWhiteGloveEngagement: {
    methodKind: "unary";
    input: typeof GetWhiteGloveEngagementRequestSchema;
    output: typeof GetWhiteGloveEngagementResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListWhiteGloveEngagements
   */
  listWhiteGloveEngagements: {
    methodKind: "unary";
    input: typeof ListWhiteGloveEngagementsRequestSchema;
    output: typeof ListWhiteGloveEngagementsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.UploadOnboardingEvidence
   */
  uploadOnboardingEvidence: {
    methodKind: "unary";
    input: typeof UploadOnboardingEvidenceRequestSchema;
    output: typeof UploadOnboardingEvidenceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.CreateReleaseJob
   */
  createReleaseJob: {
    methodKind: "unary";
    input: typeof CreateReleaseJobRequestSchema;
    output: typeof ReleaseJobResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GetReleaseJob
   */
  getReleaseJob: {
    methodKind: "unary";
    input: typeof GetReleaseJobRequestSchema;
    output: typeof ReleaseJobResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListReleaseJobs
   */
  listReleaseJobs: {
    methodKind: "unary";
    input: typeof ListReleaseJobsRequestSchema;
    output: typeof ListReleaseJobsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.RetryReleaseJob
   */
  retryReleaseJob: {
    methodKind: "unary";
    input: typeof RetryReleaseJobRequestSchema;
    output: typeof ReleaseJobResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.CancelReleaseJob
   */
  cancelReleaseJob: {
    methodKind: "unary";
    input: typeof CancelReleaseJobRequestSchema;
    output: typeof ReleaseJobResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.UpsertStoreConnection
   */
  upsertStoreConnection: {
    methodKind: "unary";
    input: typeof UpsertStoreConnectionRequestSchema;
    output: typeof UpsertStoreConnectionResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListStoreConnections
   */
  listStoreConnections: {
    methodKind: "unary";
    input: typeof ListStoreConnectionsRequestSchema;
    output: typeof ListStoreConnectionsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.PurgeCredentials
   */
  purgeCredentials: {
    methodKind: "unary";
    input: typeof PurgeCredentialsRequestSchema;
    output: typeof PurgeCredentialsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GenerateMetadata
   */
  generateMetadata: {
    methodKind: "unary";
    input: typeof GenerateMetadataRequestSchema;
    output: typeof GenerateMetadataResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.CreateWaitlistPage
   */
  createWaitlistPage: {
    methodKind: "unary";
    input: typeof CreateWaitlistPageRequestSchema;
    output: typeof WaitlistPageResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ScorePositioning
   */
  scorePositioning: {
    methodKind: "unary";
    input: typeof ScorePositioningRequestSchema;
    output: typeof ScorePositioningResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.RecordAttributionEvent
   */
  recordAttributionEvent: {
    methodKind: "unary";
    input: typeof RecordAttributionEventRequestSchema;
    output: typeof RecordAttributionEventResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GetAttributionSummary
   */
  getAttributionSummary: {
    methodKind: "unary";
    input: typeof GetAttributionSummaryRequestSchema;
    output: typeof GetAttributionSummaryResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.GenerateMonthlyReport
   */
  generateMonthlyReport: {
    methodKind: "unary";
    input: typeof GenerateMonthlyReportRequestSchema;
    output: typeof GenerateMonthlyReportResponseSchema;
  },
  /**
   * Unit 10: Decentralized Sales Enablement
   *
   * @generated from rpc guardianai.v1.distro.DistroEngineService.MatchAgentProfiles
   */
  matchAgentProfiles: {
    methodKind: "unary";
    input: typeof MatchAgentProfilesRequestSchema;
    output: typeof MatchAgentProfilesResponseSchema;
  },
  /**
   * GTM Pipeline Visibility
   *
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListSocialLeads
   */
  listSocialLeads: {
    methodKind: "unary";
    input: typeof ListSocialLeadsRequestSchema;
    output: typeof ListSocialLeadsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.ListDirectorySubmissions
   */
  listDirectorySubmissions: {
    methodKind: "unary";
    input: typeof ListDirectorySubmissionsRequestSchema;
    output: typeof ListDirectorySubmissionsResponseSchema;
  },
  /**
   * Admin Tooling
   *
   * @generated from rpc guardianai.v1.distro.DistroEngineService.AdminListReleaseJobs
   */
  adminListReleaseJobs: {
    methodKind: "unary";
    input: typeof AdminListReleaseJobsRequestSchema;
    output: typeof AdminListReleaseJobsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.AdminListWhiteGloveEngagements
   */
  adminListWhiteGloveEngagements: {
    methodKind: "unary";
    input: typeof AdminListWhiteGloveEngagementsRequestSchema;
    output: typeof AdminListWhiteGloveEngagementsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.distro.DistroEngineService.AdminGetDistroFleetMetrics
   */
  adminGetDistroFleetMetrics: {
    methodKind: "unary";
    input: typeof AdminGetDistroFleetMetricsRequestSchema;
    output: typeof AdminGetDistroFleetMetricsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_distro_distro, 0);

